// This function will sort the publishers alphabetically

function sortListPublishersAlphabetical(publishers) {
  const sortedListPublishers = publishers.sort((a, b) => {
    if (a.publisher < b.publisher) {
      return -1;
    }
    if (a.publisher > b.publisher) {
      return 1;
    }
    return 0;
  });

  return sortedListPublishers;
}

export default sortListPublishersAlphabetical;
